import { Form } from '@/shared/ui'

export const CashReceiptPersonalField = () => {
  return (
    <Form.Field name="personalIssuanceNumber">
      <Form.Label bold>휴대폰 번호 또는 현금영수증 카드 번호</Form.Label>
      <Form.TextField
        type="number"
        placeholder="휴대폰 번호/현금영수증 카드 번호를 입력해 주세요"
        fullWidth
      />
      <Form.Message />
    </Form.Field>
  )
}
